import React from 'react';
import CvFrame from '../Components/CvFrame';
import './CoffeeCv.css';

const COFFEE_CV_SRC =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3005/coffee/'
    : 'https://seanderham1.github.io/cv-section/coffee/?v=4';

// Unlinked page: reachable only by typing the URL directly. Kept free of the
// site header and footer so it reads as a standalone CV.
const CoffeeCv = () => {
  return (
    <div className="coffee-cv-container">
      <CvFrame
        src={COFFEE_CV_SRC}
        title="Sean Derham CV"
      />
    </div>
  );
};

export default CoffeeCv;
